// services/crawlService.js
import axiosInstance from './axiosInstance'; 

// Existing searchContents function
export const searchContents = async (searchParams) => {
  try {
    const response = await axiosInstance.post('/news/search', searchParams);
    return response.data;
  } catch (error) {
    console.error('Error fetching news contents:', error);
    throw error;
  }
};

// New function to publish selected news items
export const updateContent = async (newsContent) => {
  try {
    const response = await axiosInstance.put('/news', newsContent);
    return response.data;
  } catch (error) {
    console.error('Error updating news contents:', error);
    throw error;
  }
};

export const uploadThumbnail = async (formData, id) => {
  try {
      const response = await axiosInstance.post("/news/upload-thumbnail", formData, {
          headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
  } catch (error) {
      console.error("Error uploading thumbnail:", error);
  } 
};

export const fetchImage = async (id) => {
  try {
      const response = await axiosInstance.get(`/news/download-image?id=${id}`, {
          responseType: "blob", // Ensures response is treated as a binary file
      });

      // Convert blob to object URL
      const imageUrl = URL.createObjectURL(response.data);

      return imageUrl;
  } catch (error) {
      console.error("Error fetching image:", error);
      return null; // Return null on failure
  }
};


// New function to publish selected news items
export const publishContents = async (ids) => {
  try {
    const response = await axiosInstance.post('/news/contents/publish', { ids });
    return response.data;
  } catch (error) {
    console.error('Error publishing news contents:', error);
    throw error;
  }
};